
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EmbedMap',
  components: {},
  data() {},
  props: {
    jobCity: String,
    jobCountry: String,
    jobLanguage: String,
    googleApiKey: String,
  },
  mounted() {
    this.jobCity
    this.jobCountry
    this.jobLanguage
    this.googleApiKey
  },
})
